import React from "react";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/CustomButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import PrintIcon from "@material-ui/icons/PictureAsPdf";
import TableRowsIcon from "@material-ui/icons/TableChart";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Typography from "@material-ui/core/Typography";

const COLORS = {
  main: "#13816F",
  pastel1: "#CFF0EA",
  pastel2: "#E3F7F3",
};

let agencyTotal = 0;
let total_collected = 0;
let percent = 0;

let agencyGrandTotal = 0;
let totalGrandCollected = 0;
let GrandPercent = 0;

const fmtMoney = (v) =>
  typeof v === "number"
    ? v.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : Number(v || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

export default function Recap({
  title = "",
  info = {},
  forma = {},
  report_tz = "",
  timezones = {},
  onGeneratePdf,
  onGenerateCsv,
  onBack,
}) {
  return (
    <div className="container-fluid" style={{ padding: 20 }}>
      <form id="report_form">
        {Object.entries(forma || {}).map(([k, v]) => (
          <input key={k} readOnly type="hidden" name={k} value={v} />
        ))}
      </form>
      <div className="cl-mcont">
        <GridContainer style={{ paddingTop: 20 }}>
          <GridItem xs={12}>
            <div
              className="block-flat"
              style={{ padding: 20, background: "#fff", borderRadius: 8 }}
            >
              {/* Encabezado */}
              <GridContainer style={{ marginBottom: 16 }}>
                <GridItem xs={12} sm={6}>
                  <Typography variant="h6">
                    {report_tz
                      ? `${timezones?.[report_tz]} - ${report_tz.toUpperCase()}`
                      : ""}
                  </Typography>
                  <Typography variant="h5">{title}</Typography>
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<PrintIcon />}
                        onClick={() => onGeneratePdf(3, "pdf")}
                        style={{ width: "100%" }}
                      >
                        PDF
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<TableRowsIcon />}
                        onClick={() => onGenerateCsv(3, "csv")}
                        style={{ width: "100%" }}
                      >
                        CSV
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={4}>
                      <Button
                        style={{
                          background: "#FFF",
                          borderColor: COLORS.main,
                          color: COLORS.main,
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
              {/* Fecha y compañía */}
              <GridContainer style={{ marginBottom: 20 }}>
                <GridItem xs={12} sm={2}>
                  Date: {new Date().toLocaleString()}
                </GridItem>
                <GridItem
                  xs={12}
                  sm={10}
                  style={{ textAlign: "right", fontSize: 20 }}
                >
                  HDI Seguros, S.A. de C.V.
                </GridItem>
              </GridContainer>
              {/* Tabla principal */}
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    {info.details &&
                      Object.entries(info.details).map(
                        ([row_name, row_val], idx) => {
                          agencyTotal = 0;
                          return (
                            <React.Fragment key={idx}>
                              <TableRow>
                                <TableCell
                                  colSpan={13}
                                  style={{
                                    background: COLORS.main,
                                    color: "#fff",
                                    fontWeight: 700,
                                  }}
                                >
                                  {row_name}
                                </TableCell>
                              </TableRow>
                              <TableRow
                                style={{
                                  background: COLORS.pastel1,
                                  textAlign: "center",
                                  color: "#000",
                                }}
                              >
                                <TableCell>&nbsp;</TableCell>
                                <TableCell>Count</TableCell>
                                <TableCell>Cancel</TableCell>
                                <TableCell>Written</TableCell>
                                <TableCell>Refunded</TableCell>
                                <TableCell>Net</TableCell>
                                <TableCell>Policy Fee</TableCell>
                                <TableCell>IVA</TableCell>
                                <TableCell>Total</TableCell>
                                <TableCell>Commission</TableCell>
                                <TableCell>Agency Policy Fee</TableCell>
                                <TableCell>Collected / CC Fee</TableCell>
                                <TableCell>Total Due</TableCell>
                              </TableRow>
                              {Object.entries(row_val).map(
                                ([row_name, row], idx2) => {
                                  let travco = null;
                                  if (row.term === "HDI Agency (B) Sales") {
                                    agencyTotal = row.total;
                                    total_collected =
                                      parseFloat(row.collected) -
                                      parseFloat(row.percent_credit_card);
                                    percent = row.percent_credit_card;
                                  }
                                  if (row.term === "HDI Total Sales") {
                                    travco =
                                      parseFloat(agencyTotal) -
                                      parseFloat(row.commission) -
                                      parseFloat(row.agency_fee) -
                                      parseFloat(total_collected);
                                  }
                                  return (
                                    <TableRow
                                      key={idx2}
                                      className="odd gradeX"
                                      style={{ textAlign: "right" }}
                                    >
                                      <TableCell>{row.term}</TableCell>
                                      <TableCell>{row.count}</TableCell>
                                      <TableCell>{row.cancel}</TableCell>
                                      <TableCell>
                                        ${fmtMoney(row.written)}
                                      </TableCell>
                                      <TableCell>
                                        ${fmtMoney(row.refunded)}
                                      </TableCell>
                                      <TableCell>
                                        ${fmtMoney(row.net)}
                                      </TableCell>
                                      <TableCell>
                                        ${fmtMoney(row.policy_fee)}
                                      </TableCell>
                                      <TableCell>
                                        ${fmtMoney(row.iva)}
                                      </TableCell>
                                      <TableCell>
                                        ${fmtMoney(row.total)}
                                      </TableCell>
                                      <TableCell>
                                        ${fmtMoney(row.commission)}
                                      </TableCell>
                                      <TableCell>
                                        ${fmtMoney(row.agency_fee)}
                                      </TableCell>
                                      <TableCell>
                                        {row.term === "HDI Consumer (C) Sales"
                                          ? fmtMoney(percent)
                                          : row.term === "HDI Agency (B) Sales"
                                          ? fmtMoney(row.collected)
                                          : fmtMoney(total_collected)}
                                      </TableCell>
                                      <TableCell>
                                        {row.term === "HDI Total Sales" &&
                                        travco !== null
                                          ? fmtMoney(travco)
                                          : ""}
                                      </TableCell>
                                    </TableRow>
                                  );
                                }
                              )}
                            </React.Fragment>
                          );
                        }
                      )}
                    {/* Totales */}
                    <TableRow>
                      <TableCell
                        colSpan={13}
                        style={{
                          background: COLORS.main,
                          color: "#fff",
                          fontWeight: 700,
                        }}
                      >
                        Total
                      </TableCell>
                    </TableRow>
                    <TableRow
                      style={{
                        background: COLORS.pastel1,
                        textAlign: "center",
                        color: "#000",
                      }}
                    >
                      <TableCell>&nbsp;</TableCell>
                      <TableCell>Count</TableCell>
                      <TableCell>Cancel</TableCell>
                      <TableCell>Written</TableCell>
                      <TableCell>Refunded</TableCell>
                      <TableCell>Net</TableCell>
                      <TableCell>Policy Fee</TableCell>
                      <TableCell>IVA</TableCell>
                      <TableCell>Total</TableCell>
                      <TableCell>Commission</TableCell>
                      <TableCell>Agency Policy Fee</TableCell>
                      <TableCell>Collected / CC Fee</TableCell>
                      <TableCell>Total Due</TableCell>
                    </TableRow>
                    {info.totales &&
                      Object.entries(info.totales).map(
                        ([row_name, row], idx) => {
                          let travco = null;
                          if (row.term === "HDI Agency (B) Sales") {
                            agencyGrandTotal = row.total;
                            totalGrandCollected =
                              parseFloat(row.collected) -
                              parseFloat(row.percent_credit_card);
                            GrandPercent = row.percent_credit_card;
                          }
                          if (row.term === "HDI Grand (B + C) Total") {
                            travco =
                              agencyGrandTotal -
                              row.commission -
                              row.agency_fee -
                              totalGrandCollected;
                          }
                          return (
                            <React.Fragment key={idx}>
                              <TableRow
                                className="odd gradeX"
                                style={{ textAlign: "right" }}
                              >
                                <TableCell>{row.term}</TableCell>
                                <TableCell>{row.count}</TableCell>
                                <TableCell>{row.cancel}</TableCell>
                                <TableCell>${fmtMoney(row.written)}</TableCell>
                                <TableCell>${fmtMoney(row.refunded)}</TableCell>
                                <TableCell>${fmtMoney(row.net)}</TableCell>
                                <TableCell>
                                  ${fmtMoney(row.policy_fee)}
                                </TableCell>
                                <TableCell>${fmtMoney(row.iva)}</TableCell>
                                <TableCell>${fmtMoney(row.total)}</TableCell>
                                <TableCell>
                                  ${fmtMoney(row.commission)}
                                </TableCell>
                                <TableCell>
                                  ${fmtMoney(row.agency_fee)}
                                </TableCell>
                                <TableCell>
                                  {row.term === "HDI Consumer (C) Total"
                                    ? fmtMoney(GrandPercent)
                                    : row.term === "HDI Agency (B) Total"
                                    ? fmtMoney(row.collected)
                                    : fmtMoney(totalGrandCollected)}
                                </TableCell>
                                <TableCell>
                                  {row.term === "HDI Grand (B + C) Total" &&
                                  travco !== null
                                    ? "$" + fmtMoney(travco)
                                    : ""}
                                </TableCell>
                              </TableRow>
                              {row.term === "HDI Grand (B + C) Total" && (
                                <TableRow
                                  className="odd gradeX"
                                  style={{ textAlign: "right" }}
                                >
                                  <TableCell colSpan={11}></TableCell>
                                  <TableCell>Due HDI</TableCell>
                                  <TableCell>
                                    {fmtMoney(
                                      row.total -
                                        row.commission -
                                        row.agency_fee
                                    )}
                                  </TableCell>
                                </TableRow>
                              )}
                            </React.Fragment>
                          );
                        }
                      )}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* Botones inferiores */}
              <GridContainer style={{ marginTop: 16 }}>
                <GridItem xs={12} sm={6}>
                  &nbsp;
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<PrintIcon />}
                        onClick={() => onGeneratePdf(3, "pdf")}
                        style={{ width: "100%" }}
                      >
                        PDF
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<TableRowsIcon />}
                        onClick={() => onGenerateCsv(3, "csv")}
                        style={{ width: "100%" }}
                      >
                        CSV
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={4}>
                      <Button
                        style={{
                          background: "#FFF",
                          borderColor: COLORS.main,
                          color: COLORS.main,
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
